import { px, RcClasses, spacing, } from '../../../../foundation';
var RcSnackbarContentColors = {
    success: {
        textColor: 'neutral.f01',
        bgColor: 'success.b04',
    },
    error: {
        textColor: 'neutral.f01',
        bgColor: 'danger.b04',
    },
    info: {
        textColor: 'neutral.f01',
        bgColor: 'neutral.b04',
    },
    warn: {
        textColor: 'neutral.f07',
        bgColor: 'warning.b03',
    },
};
var RcSnackbarContentClasses = RcClasses(['message', 'action'], 'RcSnackbarContent');
var RcSnackbarContentPaddings = {
    small: spacing(1, 4),
    medium: spacing(3, 4),
};
var RcSnackbarContentLoadingSizes = {
    small: 16,
    medium: 20,
};
var RcSnackbarContentLineHeight = px(24);
export { RcSnackbarContentClasses, RcSnackbarContentColors, RcSnackbarContentLineHeight, RcSnackbarContentLoadingSizes, RcSnackbarContentPaddings, };
